import React, {useRef} from 'react';
import * as R from 'ramda';
import children from './../../../../assets/images/svg/002-children.svg';
import noChildren from './../../../../assets/images/svg/002-nochildren.svg';
import homechildren from './../../../../assets/images/svg/002-homechildren.svg';

import { ModalFamilyEnv } from './../../declarer/step3/modals/modalFamilyEnv';
import differenceInYears from "date-fns/differenceInYears";

export const ChildrenForm = ({ personalData, setPersonalData, isLoading, isFacilita, formReference }) => {
	const today = new Date();
	if (R.isNil(isFacilita)) {
		isFacilita = false;
	}
	let minorChildren = R.isNil(personalData.childrens) ? [] : personalData.childrens.filter((c) => differenceInYears(today, new Date(c.birthDate)) < 18);
	let youngAdults = R.isNil(personalData.childrens) ? [] : personalData.childrens.filter((c) => differenceInYears(today, new Date(c.birthDate)) > 18 && differenceInYears(today, new Date(c.birthDate)) < 21);
	let handicapedChildren = R.isNil(personalData.childrens) ? [] : personalData.childrens.filter((c) => c.isHandicaped === true);

	return (
		<div className="flex-column">
			<section className="block mt-2 pt-2">
				<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">enfants *</h4>
				<form className="py-sm" noValidate ref={formReference}>
					<div className="form-row">
						<div
							className={"form-group col col-lg-4 col-xl-2"}
							onClick={() => {
								setPersonalData({ ...personalData, hasChildren: true });
							}}>
							<div className={"card card-body text-center picker-card" + (personalData.hasChildren === true ? " active" : "")}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={children} alt="oui" />
								<h2 className="h6 font-weight-bolder my-auto">{isFacilita ? (personalData.gender === 2 || personalData.gender === "Male" ? "il avait des enfants" : "elle avait des enfants") : "J'ai des enfants"}</h2>
							</div>
						</div>
						<div
							className={"form-group col col-lg-4 col-xl-2"}
							onClick={() => {
								setPersonalData({ ...personalData, hasChildren: false });
							}}>
							<div className={"card card-body text-center picker-card" + (personalData.hasChildren === false ? " active" : "")}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={noChildren} alt="none" />
								<h2 className="h6 font-weight-bolder my-auto">{isFacilita ? (personalData.gender === 2 || personalData.gender === "Male" ? "il n'avait pas d'enfants" : "elle n'avait pas d'enfants") : "Je n'ai pas d'enfants"}</h2>
							</div>
						</div>
					</div>
					<input type="text" id="childrenFilled" className="d-none" />
					<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
				</form>
			</section>
			{personalData.hasChildren === true && !isFacilita ? (
				<section className="block mb-sm">
					<div className="flex-row mb-sm">
						<h4 className="h5 text-uppercase font-weight-bolder my-auto">Environnement familial et privé</h4>
						<button type="button" data-toggle="modal" data-target="#familyModalEnv" className="btn btn-if p-1 align-middle o-80 o-100--hover ml-auto">
							<i className="eva eva-edit-2-outline align-middle fs-lead btn-icon"></i>
							<span className="btn-text ml-2">Modifier</span>
						</button>
					</div>
					<div className="grid grid-sm-2 grid-lg-3 grid-xl-5 gy-3">
						<div className="flex-row align-items-center">
							<img className="img-fluid mr-3 h-4" src={children} alt="maison" />
							<div className="my-auto">
								<p className="h6 text-uppercase font-weight-bold my-auto o-70">enfants</p>
								<p className="h3 text-uppercase font-weight-bold my-auto">{personalData.childrens.length}</p>
							</div>
						</div>
						<div className="flex-row align-items-center">
							<img className="img-fluid mr-3 h-4" src={noChildren} alt="-18" />
							<div className="my-auto">
								<p className="h6 text-uppercase font-weight-bold my-auto o-40"> &lt; 18 ans</p>
								<p className="h6 text-uppercase font-weight-bold my-auto">{minorChildren.length} mineur(s)</p>
							</div>
						</div>
						<div className="flex-row align-items-center">
							<img className="img-fluid mr-3 h-4" src={noChildren} alt="-18" />
							<div className="my-auto">
								<p className="h6 text-uppercase font-weight-bold my-auto o-40"> 18 à 21 ans</p>
								<p className="h6 text-uppercase font-weight-bold my-auto">{youngAdults.length} majeur(s)</p>
							</div>
						</div>
						<div className="flex-row align-items-center">
							<img className="img-fluid mr-3 h-4" src={noChildren} alt="+21" />
							<div className="my-auto">
								<p className="h6 text-uppercase font-weight-bold my-auto o-40"> &gt; 21 ans</p>
								<p className="h6 text-uppercase font-weight-bold my-auto">{personalData.childrens.length - minorChildren.length - youngAdults.length} majeur(s)</p>
							</div>
						</div>
						<div className="flex-row align-items-center">
							<img className="img-fluid mr-3 h-4" src={homechildren} alt="handicapée" />
							<div className="my-auto">
								<p className="h6 text-uppercase font-weight-bold my-auto o-40">handicapée(s)</p>
								<p className="h6 text-uppercase font-weight-bold my-auto">{handicapedChildren.length} personne(s)</p>
							</div>
						</div>
					</div>
					<ModalFamilyEnv deathDeclaration={personalData} userId={personalData.userId} isLoading={isLoading} />
				</section>
			) : (
				""
			)}
		</div>
	);
};